import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type SectionNavigationClasses =
  | 'root'
  | 'buttonsContainer'
  | 'toggleButton'
  | 'endIcon'
  | 'endIconOpen'
  | 'menuItem'
  | 'dropdownMenu'
  | 'dropdownMenuList'
  | 'currentIndex'
  | 'toggleButtonDisabled'
  | 'label'
  | 'checkIcon'
  | 'customiseLabel';

const sectionNavigationStyles = makeStyles<ISpcTheme, SectionNavigationClasses>(
  ({ palette, shadows, typography }) => ({
    root: {},
    toggleButton: {
      color: palette.common.white,
      backgroundColor: 'transparent',
      fontSize: typography.fontMD,
      padding: '4px 8px',
      '&:hover': {
        color: palette.common.white,
        backgroundColor: 'transparent',
        '& > span:last-child': {
          opacity: 1,
        },
      },
    },
    dropdownMenu: {},
    endIcon: {
      color: palette.common.white,
      transform: 'rotate(-90deg)',
    },
    endIconOpen: {
      transform: 'rotate(90deg)',
    },
    dropdownMenuList: {
      padding: 0,
      backgroundColor: palette.secondary.light,
      display: 'flex',
      flexDirection: 'column',
      boxShadow: shadows[1],
    },
    menuItem: {
      '&:hover': {
        backgroundColor: palette.grey[600],
      },
    },
    buttonsContainer: {
      overflowX: 'auto',
      scrollBehavior: 'smooth',
    },
    currentIndex: {
      marginRight: 3,
      '&::after': {
        content: '"."',
      },
    },
    toggleButtonDisabled: {
      color: palette.common.white,
      backgroundColor: 'transparent',
      '&.Mui-disabled': {
        color: palette.common.white,
      },
    },
    label: {},
    checkIcon: {
      marginRight: '5px',
    },
    customiseLabel: {},
  }),
  { name: 'Customise_SectionNavigation' },
);

export default sectionNavigationStyles;
